import $ from 'jquery';

import consumer from './consumer';

consumer.subscriptions.create('WebNotificationsChannel', {
  received: function(data) {
    if (data.type === 'list_summary_complete') {
      window.location.href = `/lists/${data.list_id}/edit`;
    } else {
      let progress = '<i class="fas fa-spinner fa-pulse me-1"></i>';
      progress += data.message;
      $('.pdf-upload-progress').html(progress);
    }
  }
});
